import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
const cartProducts = localStorage.getItem("products");
const initialState = cartProducts ? JSON.parse(cartProducts) : [];
const cartSlice = createSlice({
  initialState,
  name: "cartSlice",
  reducers: {
    addProduct: (state, action) => {
      const storeProduct = state.find((product) =>
        _.isEqual(product.productDetails, action.payload.productDetails)
      );
      if (storeProduct) storeProduct.quantity++;
      else
        state.push({
          productDetails: action.payload.productDetails,
          quantity: 1,
        });
    },
    removeProduct: (state, action) => {
      const storeProduct = state.find((product) =>
        _.isEqual(product.productDetails, action.payload.productDetails)
      );
      if (storeProduct) {
        if (storeProduct.quantity <= 1) {
          return state.filter(
            (remainingProduct) => remainingProduct !== storeProduct
          );
        }
        if (storeProduct.quantity > 0) {
          storeProduct.quantity--;
        }
      }
    },
    changeAttribute: (state, action) => {
      const storeProduct = state.find((product) =>
        _.isEqual(product.productDetails, action.payload.productDetails)
      );
      const changedProduct = {
        productDetails: {
          ...action.payload.productDetails,
          selectedAttributes: action.payload.selectedAttributes,
        },
      };
      const existingProduct = state.find((product) =>
        _.isEqual(product.productDetails, changedProduct.productDetails)
      );
      if (storeProduct && !existingProduct) {
        storeProduct.productDetails = {
          ...action.payload.productDetails,
          selectedAttributes: action.payload.selectedAttributes,
        };
      }
    },
  },
});
export default cartSlice.reducer;
export const { addProduct, removeProduct, changeAttribute } = cartSlice.actions;
